export default __webpack_public_path__ + "static/ande-noktes-9ffcf23f03befdf091db27f72d7adc75.png";